import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ENVIRONMENT,
  FilterOptions,
  GridData,
  HTTPResponseList,
  ListOptions
} from '@ot/shared/model';
import { LocalDateTime, ZoneId } from 'js-joda';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  Environment,
  EnvironmentConfigService,
  IftaServiceName
} from '../environment';
import { TaxAccount } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TaxAccountService {
  private serviceUrl: string;
  private serviceUrlVehicleTaxAccount: string;

  constructor(
    @Inject(ENVIRONMENT) environment: Environment,
    private http: HttpClient,
    environmentConfigService: EnvironmentConfigService
  ) {
    this.serviceUrl =
      environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
      '/' +
      environment.serviceUrlList[IftaServiceName.TaxAccountService];
    this.serviceUrlVehicleTaxAccount =
      environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
      '/' +
      environment.serviceUrlList[IftaServiceName.VehicleTaxAccountService];
  }

  // TODO: Move VehicleExtensionService to shared instead of having duplicated methods
  getTaxAccounts(
    options: ListOptions,
    businessAccountId: string
  ): Observable<GridData<TaxAccount>> {
    const filterObject: FilterOptions = {
      options,
      filter: {
        global: {
          businessAccountIds: [{ value: businessAccountId }]
        }
      }
    };
    return this.http
      .post<HTTPResponseList<TaxAccount>>(
        `${this.serviceUrl}/tax_account/list`,
        filterObject
      )
      .pipe(
        map(response => ({
          items: response.taxAccounts,
          totalSize: +response.totalCount
        }))
      );
  }

  // TODO: Move VehicleExtensionService to shared instead of having duplicated methods
  getUnassignedVehicleIds(businessAccountId: string): Observable<string[]> {
    return (
      this.http
        // Array of VehicleTaxAccount type here (in ifta lib)
        .get<{ vehicleTaxAccount: any[] }>(
          `${
            this.serviceUrl
          }/unassigned/vehicle_tax_account/${businessAccountId}`
        )
        .pipe(
          map(response => response.vehicleTaxAccount),
          map(vehicleTaxAccount =>
            vehicleTaxAccount.map(vehicle => vehicle.vehicleId.value)
          )
        )
    );
  }

  // TODO: Move VehicleExtensionService to shared instead of having duplicated methods
  getVehicleIdsForTaxAccount(
    businessAccountId: string,
    taxAccountId: string
  ): Observable<string[]> {
    // TODO: use `const request: APIGetVehicleTaxAccountsRequest` typing
    const request = {
      businessAccountId: { value: businessAccountId },
      taxAccountId: { value: taxAccountId },
      startDate: '2018-01-01T00:00:00Z',
      endDate: LocalDateTime.now()
        .atZone(ZoneId.UTC)
        .toString(),
      includeIftaDisabledVehicles: true
    };
    // TODO: use `.post<APIGetVehicleTaxAccountsResponse>` typing
    return this.http
      .post<any>(
        `${this.serviceUrlVehicleTaxAccount}/vehicle_tax_accounts`,
        request
      )
      .pipe(
        map(response =>
          response.vehicleTaxAccount.map(
            vehicleTaxAccount => vehicleTaxAccount.vehicleId.value
          )
        )
      );
  }
}
